import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';

import { CustomerPropertiesDto } from '@/api/generated';
import { DetailsViewItem } from '@/components/detailView/DetailsViewItem.comp.tsx';
import { DetailsViewWrapper } from '@/components/detailView/DetailsViewWrapper.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  customer: Partial<Omit<CustomerPropertiesDto, 'address'>> | null;
  title: string;
};

export const CustomerShortDetails: React.FC<Props> = props => {
  const { customer, title } = props;
  const { t } = useTranslationWithPrefix('views.customers.table.body');

  if (!customer) {
    return null;
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography sx={{ pb: 2 }} variant="f12Regular">
        {title}
      </Typography>
      <DetailsViewWrapper>
        <DetailsViewItem title={t('name')} value={customer.name} />
        <DetailsViewItem
          title={t('type')}
          value={customer.flag ? t(`typeOption.${customer.type}`) : ''}
        />
        <DetailsViewItem
          title={t('status')}
          value={customer.status ? t(`statusOption.${customer.status}`) : ''}
        />
        <DetailsViewItem
          title={t('flag')}
          value={customer.flag ? t(`flagOption.${customer?.flag}`) : ''}
        />
      </DetailsViewWrapper>
    </Paper>
  );
};
